import { ReactNode } from "react";

export const MiniHeader = ({
  header,
  subheader,
  className = "",
}: {
  header: ReactNode;
  subheader?: string;
  className?: string;
}) => {
  return (
    <>
      <div className={`text-base font-bold text-grey-950 ${className}`}>
        {header}
      </div>
      {subheader && <p className="text-sm text-grey-500">{subheader}</p>}
    </>
  );
};
